import React, { useState } from 'react';
import {
  Box, Typography, TextField, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Paper, Chip, InputAdornment,
} from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';
import { productos, formatearMoneda } from '../data';

function Products() {
  const [busqueda, setBusqueda] = useState('');

  const filtrados = productos.filter((p) => {
    if (!busqueda) return true;
    const q = busqueda.toLowerCase();
    return p.nombre.toLowerCase().includes(q) || p.codigo_barras.includes(q) || p.categoria.toLowerCase().includes(q);
  });

  return (
    <Box>
      <Typography variant="h4" fontWeight={700} mb={3}>Productos</Typography>

      <TextField
        placeholder="Buscar por nombre, código o categoría..."
        value={busqueda}
        onChange={(e) => setBusqueda(e.target.value)}
        size="small"
        sx={{ mb: 2, maxWidth: 400 }}
        InputProps={{
          startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
        }}
      />

      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Código</TableCell>
              <TableCell>Nombre</TableCell>
              <TableCell>Categoría</TableCell>
              <TableCell align="right">Precio Venta</TableCell>
              <TableCell align="right">Precio Mayoreo</TableCell>
              <TableCell align="center">Stock</TableCell>
              <TableCell align="center">Estado</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filtrados.map((p) => (
              <TableRow key={p._id} hover>
                <TableCell sx={{ fontFamily: 'monospace', fontSize: '0.8rem' }}>{p.codigo_barras}</TableCell>
                <TableCell>
                  <Typography variant="body2" fontWeight={500}>{p.nombre}</Typography>
                  <Typography variant="caption" color="text.secondary">{p.descripcion}</Typography>
                </TableCell>
                <TableCell>{p.categoria} / {p.subcategoria}</TableCell>
                <TableCell align="right">{formatearMoneda(p.precio_venta_publico)}</TableCell>
                <TableCell align="right">{formatearMoneda(p.precio_mayoreo)}</TableCell>
                <TableCell align="center">
                  <Chip
                    label={p.stock}
                    size="small"
                    color={p.stock <= p.stock_minimo ? 'error' : p.stock < 10 ? 'warning' : 'success'}
                    variant="outlined"
                  />
                </TableCell>
                <TableCell align="center">
                  <Chip label={p.activo ? 'Activo' : 'Inactivo'} size="small" color={p.activo ? 'success' : 'default'} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Typography variant="caption" color="text.disabled" mt={1} display="block">
        Mostrando {filtrados.length} de {productos.length} productos
      </Typography>
    </Box>
  );
}

export default Products;
